import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import ResetpasswordError from './Resetpassworderror';
import { Resetpasswordrouteparams } from './Resetpassword.types';
import { verifyTokenService } from '../../../services/Auth/Auth';
import { Changepasswordcontext } from '../../../context/Changepassword/Changepassword';
import Spinner from '../../../components/Spinner/Spinner';

const Verifytoken = () => {
  const [error, setError] = React.useState<boolean>(false);
  const { updateContext } = React.useContext(Changepasswordcontext);
  const { token } = useParams<Resetpasswordrouteparams>();
  const history = useHistory();

  const verifyTokenRequest = React.useCallback(async () => {
    try {
      const username = await verifyTokenService(token);
      updateContext(username, token);
      history.replace('/changepassword');
    } catch (error) {
      setError(true);
    }
  }, [token, updateContext, history]);

  React.useEffect(() => {
    verifyTokenRequest();
  }, [verifyTokenRequest]);

  return error ? <ResetpasswordError /> : <div className="state-page"><Spinner label="Verificando enlace de recuperación" /></div>;
};

export default Verifytoken;
